import { shellConfig } from '@/core/config';

export default (to, from, savedPosition) => {
  if (!savedPosition) {
    if (to.meta.layout && to.meta.layout === shellConfig.layout.stacked) return true;
    return { x: 0, y: 0 };
  }
  return savedPosition;
};
